import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Scassinatore** (manuale V1, rr. 1411-1417).
 *
 * Trappole, serrature, "lavoretti" vari. Tuttofare durante l'accampamento.
 */
export const scassinatore: FollowerAbility = {
  id: 'scassinatore',
  label: 'Scassinatore',
  description:
    'Una figura ambigua (a dir poco), al confine tra crimine e legalità (se lavorare al nero è legale). Abile con trappole e "lavoretti" vari, è indispensabile se vuoi avventurarti in luoghi pericolosi o se hai perso le chiavi.',
  ranks: [
    {
      rank: 1,
      trigger:
        'Quando uno Scassinatore ti *aiuta* a individuare una trappola o a disinnescarla, a trovare un passaggio segreto o ad aprire una serratura',
      description:
        'Prendi +1 al tiro che devi fare. Dopo che ha usato questa mossa, lo Scassinatore non può usarla di nuovo fintanto che non vi *accampate*.',
    },
    {
      rank: 2,
      trigger: 'Quando vi *accampate*',
      description:
        'Uno Scassinatore può trasformarsi in un vero e proprio "tuttofare"! Può riparare un oggetto rotto, oppure rifornirti di 1 utilizzo di *munizioni* (del tipo che vuoi) o di Attrezzatura da Avventuriero. Se una riparazione è davvero "tosta", potrebbe volerci più di un tentativo per realizzarla (a discrezione del GM).',
    },
    {
      rank: 3,
      trigger: 'Quando uno Scassinatore "apre la strada"',
      description:
        'Fiuta le trappole prima che diventino un problema, avvertendoti in tempo utile.',
    },
  ],
};
